export enum EQueryIdType {
  userId = 'user_id',
  clientId = 'client_id',
}
